//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
    data() {
        return {
            selected: '复诊医生',
            doctorList: []
        }
    },
    //生命周期之挂载完成
    methods: {
        getOrderList(){
            let params = {
                    patientid: this.$store.state.userInfo.id,
                    addtype: '',//不传返回绑定的医生，3全部医生
            };
            this.$doRequest("/api/Inquiry/GetDoctorsTwo", params).then(res => {
                this.doctorList = res.pageVal;
            })
        }
    },
    //生命周期之创建完成
    created: function(){
        this.$isLogin(window.location.search.substr(1), this.getOrderList);
        document.title = '我的医生';
    },
}



// WEBPACK FOOTER //
// ./src/views/myDoctor/index.vue